<template>
  <v-container
    ref="container"
    fluid
  >
    <v-row v-if="!!categoryStores.length">
      <v-col cols="12">
        <h2>{{ category.Name }} - {{ $tc('Store.Title', 0) }}</h2>
      </v-col>

      <template v-for="(store, idx) in categoryStores">
        <v-col
          v-if="!storeIsHidden(store)"
          :key="`store-${idx}`"
          cols="12"
          lg="4"
          sm="6"
          xl="3"
        >
          <store-card
            :item="store"
            :to="{name: 'Store', params: {slug: store.Slug, id: store.Id}}"
            hover
          />
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import CategoryMixin from '@/theme/default/views/category/Category.js'

export default {
  name  : 'Category',
  mixins: [CategoryMixin]
}
</script>

<style scoped src="@/theme/default/views/category/Category.css"></style>
<style scoped>
</style>
